export const numberToString = number => number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const stringTo2PointDecimal = number => (Math.round(number * 100) / 100).toFixed(2);
